import { renderLabel_unstable } from '@fluentui/react-label';

/**
 * Renders the final JSX of the Label component, given the state.
 */
export const renderLabel = renderLabel_unstable;
